import * as React from 'react';

import { BxMobileBx687NewMainpageExperiment } from '../../constants/experimentsAb';

type TMainPageExperimentProps = {
  legacy: React.ReactNode;
  redesigned: React.ReactNode;
  isMainPage: boolean;
};

/**
 * Хелпер выбирает между легаси и редизайн-вариантом для главной в рамках эксперимента.
 * Не main-page брендинг (другие лендинги в группе B) остаётся на легаси-варианте.
 */
export const MainPageExperiment: React.FC<TMainPageExperimentProps> = ({ legacy, redesigned, isMainPage }) => (
  <BxMobileBx687NewMainpageExperiment>
    <BxMobileBx687NewMainpageExperiment.Group name="A">{legacy}</BxMobileBx687NewMainpageExperiment.Group>
    <BxMobileBx687NewMainpageExperiment.Group name="B">
      {isMainPage ? redesigned : legacy}
    </BxMobileBx687NewMainpageExperiment.Group>
  </BxMobileBx687NewMainpageExperiment>
);
